// extracted by mini-css-extract-plugin
export default {"p":"styles_p__BExFE","h":"styles_h__c+Ejv"};